import React, { useEffect, useRef, useState } from 'react';
import axios from "axios"
import { HomeForm } from './HomeForm';
import { baseUrl } from '../index';
import loader from '../Images/SmcLoader.png';
import { convertIntoLakh, CommaSeprator } from './Utilities';
import CircleLoader from './CircleLoader';
import { useLocation } from 'react-router-dom';
import QuoteFooter from './QuoteFooter';
import TalkExperts from '../TalkExperts/TalkExperts';
import CopyToClipboard from 'react-copy-to-clipboard';
import { BsStars } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa6";
import html2pdf from "html2pdf.js";
import { Modal } from 'react-bootstrap';
import CrossIcon from '../Images/Cross-icon.svg';
import PlanDetailsPopup from './ChildComponents/PlanDetailsPopup';

const Quotation = (props) => {
    const location = useLocation();
    const [QuoteReq, setQuoteReq] = useState({});
    const [Quotes, setQuotes] = useState([]);
    const [InsurerList, setInsurerList] = useState([]);
    const [selectedInsurer, setSelectedInsurer] = useState("");
    const [IsEditForm, setEditForm] = useState(false);
    const [isLoader, setLoader] = useState(true);
    const [isBuyLoader, setBuyLoader] = useState(false);
    const [gst, setGst] = useState(false);
    const [copyText, setCopyText] = useState(false);
    const [isDownlodPDF, setIsDownlodPDF] = useState(false)
    const [showPopup, setShowPopup] = useState(false);
    const [isShowAllQuote, setIsShowAllQuote] = useState(false)
    const [isPdfBTN, setIsPdfBTN] = useState(true)
    const ref = useRef(true);
    useEffect(() => {
        if (location.state) {
            setQuoteReq(location.state);
            console.log(location.state, "location.state");
        }
    }, [location.state]);
    useEffect(() => {
        if (ref.current) {
            ref.current = false;
            return;
        }
        GenerateQuote()
    }, [QuoteReq])

    console.log(QuoteReq, "QuoteReq");

    useEffect(() => {
        setLoader(props.QuoteLength > 0 ? false : true);
    }, [props.QuoteLength])
    const GenerateQuote = () => {
        setQuotes([]);
        QuoteReq.Email = "";
        QuoteReq.CoverName = QuoteReq.TypeofSpecialization;
        axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, {
            URL: "GenerateQuote_PI",
            PostString: JSON.stringify(QuoteReq)
        }).then(Res => {
            if (Res.data.StatusCode === 200) {
                setLoader(false);
                setQuotes([Res.data.Response]);
                setInsurerList([...InsurerList, Res.data.Response.CompanyName]);
            } else setQuotes([]);

        })
            .catch(err => { console.log(err.message) })
    }

    console.log(Quotes, "Quotes");

    const BuyNow = (e, data) => {
        e.persist()

        setBuyLoader(true);

        axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, {
            URL: "SaveQuote_PI",
            PostString: JSON.stringify({
                "TransKey": data.TransKey,
                "EnquiryNo": data.EnquiryNo
            })
        }).then(Res => {
            if (Res.data.IsSuccess) {
                QuoteReq.BuyNowTransKey = Res.data.TransKey;
                props.history.push("proposal", { QuoteReq, BuyNow: data });
                setBuyLoader(false);
            } else {
                e.target.value = "Invest Now";
            }
        }).catch(err => { e.target.value = "Invest Now"; });

    }

    const handleGst = (e) => {
        const isChecked = e.target.checked;
        setGst(isChecked);
    };

    const handleCopy = () => {
        setCopyText(true);
        setTimeout(() => setCopyText(false), 2000);
    };
    const generatePDF = async () => {
        setIsDownlodPDF(true);
        setIsPdfBTN(false);
        setIsShowAllQuote(true);

        // Wait for UI update
        setTimeout(async () => {
            const elementsToHide = document.querySelectorAll('.hide-this-in-pdf');
            const PlansHead = document.querySelectorAll('.quotesDetailsInHLT_Cust');
            const fullWidth = document.querySelectorAll('.fullWidth');
            const linkIcons = document.querySelectorAll('.link-with-iconPDF');

            elementsToHide.forEach(el => el.classList.add('hide-in-pdf'));
            PlansHead.forEach(el => el.classList.add('PlansHead'));
            fullWidth.forEach(el => el.classList.add('col-md-12'));
            linkIcons.forEach(el => el.style.display = "block");

            const element = document.getElementById("CaptureProposal");

            if (!element) {
                console.error("Element not found: #CaptureProposal");
                setIsDownlodPDF(false);
                setIsPdfBTN(true);
                return;
            }

            const opt = {
                margin: 0,
                filename: QuoteReq?.EnquiryNo?.replace("/", "_") + "_Quotaion_Summary.pdf",
                image: { type: "jpeg", quality: 1 },
                html2canvas: { scale: 1.5, useCORS: true }, // scale 8 is too high; try 2 or 3
                jsPDF: {
                    unit: "px",
                    format: [1120, 1500], // width x height
                    orientation: "portrait",
                    putOnlyUsedFonts: true,
                },
                enableLinks: true,
                pagebreak: {
                    mode: ["avoid-all", "css", "legacy"],
                    before: ".page-break",
                },
            };

            try {
                await html2pdf().set(opt).from(element).save();
            } catch (e) {
                console.error("PDF Generation Error:", e);
            }

            // Clean up
            elementsToHide.forEach(el => el.classList.remove('hide-in-pdf'));
            PlansHead.forEach(el => el.classList.remove('PlansHead'));
            fullWidth.forEach(el => el.classList.remove('col-md-12'));
            linkIcons.forEach(el => el.style.display = "none");

            setIsShowAllQuote(false);
            setIsDownlodPDF(false);
        }, 500); // 500ms delay
    };

    console.log(gst, "gst")
    return (
        <>
            {isDownlodPDF ? (
                <div className="IsDownlodPDF">
                    <span className="PDFloader"></span>{" "}
                    <span className="PDFloaderText">Generating PDF</span>
                </div>
            ) : (
                ""
            )}
            <div className="IndemQute" id="CaptureProposal">
                <div className="container" ref={ref}>
                    <div className="IndemnityUIQuotation">
                        <div className="row">
                            <div className="col-md-8 fullWidth">
                                <div className="ExclusiveGSTRow">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <h3 className="PlansCount">
                                                <span>
                                                    {isLoader ?
                                                        <img className="load" src={loader} alt="" />
                                                        :
                                                        Quotes.length}
                                                </span>
                                                {Quotes.length === 1 ? " Plan " : Quotes.length === 0 ? " No Plan " : " Plans "} Found
                                            </h3>
                                            <p class="LeadIdHover">
                                                <strong class="ng-binding">
                                                    <CopyToClipboard text={QuoteReq.EnquiryNo} onCopy={handleCopy}>
                                                        <span>{QuoteReq.EnquiryNo} <i className="far fa-clone hide-this-in-pdf"></i></span>
                                                    </CopyToClipboard>
                                                    {copyText && <div className="Enq_popup">Copied!</div>}
                                                </strong>
                                            </p>
                                        </div>
                                        <div className="col-md-7 d-flex align-items-end hide-this-in-pdf">
                                            <div class="form-check form-switch gst_switch ENQ_box">
                                                {/*<label class="gst-toggle-label">
                                                    <span class="text_gst LeadID">Premium with GST</span>
                                                    <input className="form-check-input check_gst" type="checkbox" role="switch" id="flexSwitchCheckChecked"
                                                        checked={gst} onChange={handleGst} />
                                                </label>*/}
                                                <span class="text_gst">Premium with GST</span>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        name="Organization"
                                                        onChange={handleGst}
                                                        checked={gst}
                                                        role="switch" id="flexSwitchCheckChecked"
                                                    />
                                                    <span className="sliderToggle round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <a
                                        href={`${window.location.origin + window.location.pathname}?policyEnq=${QuoteReq?.EnquiryNo}`}
                                        className="link-with-iconPDF"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ marginBottom: 10 }}
                                    >
                                        Continue Journey
                                        <i class="fas fa-arrow-right"></i>
                                    </a>
                                </div>
                                {Quotes.length > 1 &&
                                    <div className="row align-items-end PlanFounds hide-this-in-pdf">

                                        <div className="col-md-3 offset-md-6 insurerSelt">
                                            <p>Insurers</p>
                                            <select id="" name="" value={selectedInsurer} onChange={e => setSelectedInsurer(e.target.value)} >
                                                <option value="">Select Insurers</option>
                                                {InsurerList.map((r, i) => <option value={r} key={i}>{r}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                }
                                {Quotes.map((row, i) =>
                                    <div key={i} className="quotesBoxesMargine">
                                        <div className="IndemnityDetails">

                                            <div className="Indemnity_Logo">
                                                <img src={row.LogoURL} alt="Logo" />
                                                <div className="ProtectBox">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="#30b524">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className="Indemnity_Feature">
                                                <div className="PremiumBox">
                                                    <small>{row.PlanName}</small>
                                                    <div className="Indemnity_SumIns">
                                                        <div className="CoveredAmount">
                                                            <span>Covered amount: </span><span>{convertIntoLakh(row.SumInsured)}</span>
                                                            <span className="d-block PlanDetails" onClick={() => setShowPopup(true)}>Plan Details<i class="fas fa-chevron-right"></i></span>
                                                        </div>
                                                        <div className="Indemni_Premiu">
                                                            <div className="IPremium text-center">
                                                                {isBuyLoader ?
                                                                    <a className="QuotNBtn btn-block" id="BuyNow" name="BuyNow"><CircleLoader /></a>
                                                                    :
                                                                    <a className="QuotNBtn btn-block" id="BuyNow" name="BuyNow" onClick={(e) => BuyNow(e, row)}>₹ <span className="buyme ng-binding">{CommaSeprator(Math.round(!gst ? row.NetPremium : row.TotalPremium))} <i class="fas fa-chevron-right"></i></span>
                                                                    </a>
                                                                }
                                                                <div className="PerMonthVal"><span>₹ {CommaSeprator(Math.round(!gst ? row.NetPremium / 12 : row.TotalPremium / 12))} /month</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <PlanDetailsPopup show={showPopup} handleClose={() => setShowPopup(false)} QuotesData={row} BuyNow={(e) => BuyNow(e, row)} QuoteReq={QuoteReq} />
                                                </div>

                                            </div>


                                            {/*<div class="row mt-3">*/}
                                            {/*    <div className="col-md-4">*/}
                                            {/*        <div class="bg-gray-50 rounded-lg p-6 text-center">*/}
                                            {/*            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 mx-auto mb-3 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">*/}
                                            {/*                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>*/}
                                            {/*            </svg>*/}
                                            {/*            <p class="text-base text-gray-600">Comprehensive Coverage</p>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*    <div className="col-md-4">*/}
                                            {/*        <div class="bg-gray-50 rounded-lg p-6 text-center">*/}
                                            {/*            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 mx-auto mb-3 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">*/}
                                            {/*                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>*/}
                                            {/*            </svg>*/}
                                            {/*            <p class="text-base text-gray-600">Quick Claims Process</p>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*    <div className="col-md-4">*/}
                                            {/*        <div class="bg-gray-50 rounded-lg p-6 text-center">*/}
                                            {/*            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 mx-auto mb-3 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">*/}
                                            {/*                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>*/}
                                            {/*            </svg>*/}
                                            {/*            <p class="text-base text-gray-600">24/7 Support</p>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                        </div>
                                    </div>)
                                }{/*</> } */}

                            </div>
                            <div className="col-md-4 hide-this-in-pdf">
                                <div className="QuotationDetails">
                                    <div className="QD_Head">
                                        <h4>Your Details</h4>
                                        <div className="edit_btn">
                                            <button onClick={() => setEditForm(!IsEditForm)}><i class="fas fa-pencil-alt"></i> Edit</button>
                                        </div>
                                    </div>
                                    <div className="Details">
                                        <p>Profession</p>
                                        <small>Doctor</small>
                                    </div>
                                    <div className="Details">
                                        <p>Specialization</p>
                                        <small>
                                            {QuoteReq.TypeofSpecializationLabel}
                                        </small>
                                        {/*<div className="QuestionPopupInnerPage">
                                            {QuoteReq.TypeofSpecializationLabel}
                                        </div>*/}
                                    </div>
                                    <div className="Details">
                                        <p>Covered amount</p>
                                        <small>{convertIntoLakh(QuoteReq.SumInsured)}</small>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8">
                                <div className="hide-this-in-pdf">
                                    <QuoteFooter />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="quote-footer-container">
                                    <TalkExperts mobile={QuoteReq.MobileNo}
                                        prefertime="Evening(9am - 6pm)"
                                        EnquiryTypeList="Health Insurance" />
                                </div>
                            </div>
                        </div>
                        <div className="CallRequest hide-this-in-pdf">
                            <button
                                onClick={() => generatePDF()}
                                className="showOpt"
                                id="MoreOption"
                            >
                                <span>
                                    <BsStars />
                                </span>
                                <span>
                                    <FaRegFilePdf />
                                </span>
                                <span>Generate PDF</span>
                            </button>
                        </div>
                    </div>
                </div>
                {/*<HomeForm enquiryNo={QuoteReq.EnquiryNo} onClose={() => setEditForm(false)} isEditForm={IsEditForm} onSubmit={data => { setQuoteReq(data); setEditForm(false); }}*/}
                {/*    prevData={QuoteReq} mobileNo={QuoteReq.MobileNo} Dob={QuoteReq.DOB} specialization={QuoteReq.TypeofSpecialization}*/}
                {/*    suminsured={QuoteReq.SumInsured} btnupdate={"Update"} />*/}


                <Modal show={IsEditForm} onHide={() => setEditForm(false)} size="md" backdrop="static" centered>
                    <Modal.Header closeButton className="userFormModalHeader pb-3 pt-3">
                        <Modal.Title>Edit Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <div className="indemnity_userform indem">
                            <HomeForm enquiryNo={QuoteReq.EnquiryNo} isEditForm={true} onSubmit={data => { setQuoteReq(data); setEditForm(false); }}
                                prevData={QuoteReq} mobileNo={QuoteReq.MobileNo} Dob={QuoteReq.DOB} specializationQT={QuoteReq.TypeofSpecialization}
                                suminsuredQT={QuoteReq.SumInsured} btnupdate={"Update"} />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
}

export default Quotation;
